// src/views/Parametros/ParametrosGrales/CrearParametro.jsx
import React, { useState, useEffect } from "react";
import { FaTimes} from "react-icons/fa";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";
import InputNumberNoScroll from "../../../components/inputs/inputNumberNoScroll";
import BtnGuardar from "../../../components/buttons/BtnGuardar";

export default function CrearParametro({
  onClose = () => {},
  onCreated = () => {},
}) {
  // Campos obligatorios
  const [nombre, setNombre] = useState("");
  const [valor, setValor] = useState("");
  const [fecha, setFecha] = useState(new Date().toISOString().slice(0, 10));
  const [numero, setNumero] = useState("");
  const [prioridad, setPrioridad] = useState("");

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // Cerrar con ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const guardar = async () => {
    setError("");

    if (
      !nombre.trim() ||
      !valor.trim() ||
      !fecha.trim() ||
      numero === "" ||
      prioridad === ""
    ) {
      setError("Todos los campos son obligatorios.");
      return;
    }

    setSaving(true);

    try {
      const payload = {
        nombre: nombre.trim(),
        valor: valor.trim(),
        fecha: fecha.trim(), // texto, backend decide parseo
        numero: Number(numero),
        prioridad: Number(prioridad),
      };

      const created = await appFetchJson(apiRoutes.parametros.create, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      onCreated(created);
      onClose();
    } catch (e) {
      console.error("Error creando parámetro:", e);
      setError(e?.message || "Ocurrió un error al guardar.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
        {/* HEADER */}
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Crear Parámetro</h2>

          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* BODY */}
        <div className="modal-body">
          {error && <div className="text-red-600 mb-3">{error}</div>}

          <div className="form-grid">
            {/* NOMBRE */}
            <div className="form-row">
              <label className="form-label">Nombre *</label>
              <input
                type="text"
                className="input"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
              />
            </div>

            {/* VALOR */}
            <div className="form-row">
              <label className="form-label">Valor *</label>
              <input
                type="text"
                className="input"
                value={valor}
                onChange={(e) => setValor(e.target.value)}
              />
            </div>

            {/* FECHA */}
            <div className="form-row">
              <label className="form-label">Fecha *</label>
              <input
                type="date"
                className="input"
                placeholder="Ej: 29-ene-2015 0:00:00"
                value={fecha}
                onChange={(e) => setFecha(e.target.value)}
              />
            </div>

            {/* NÚMERO */}
            <div className="form-row">
              <label className="form-label">Número *</label>
              <InputNumberNoScroll
                className="input w-full h-[38px] bg-white border rounded px-3"
                value={numero}
                onChange={(e) => setNumero(e.target.value)}
              />
            </div>

            {/* PRIORIDAD */}
            <div className="form-row">
              <label className="form-label">Prioridad *</label>
              <InputNumberNoScroll
                className="input w-full h-[38px] bg-white border rounded px-3"
                value={prioridad}
                onChange={(e) => setPrioridad(e.target.value)}
              />
            </div>

          </div>
        </div>

        {/* FOOTER - Botones Guardar & Cancelar --Inicio*/}
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar
  label="Guardar"
  isValid={
    nombre.trim() !== "" &&
    valor.trim() !== "" &&
    fecha.trim() !== "" &&
    numero !== "" &&
    prioridad !== ""
  }
  saving={saving}
  onClick={guardar}
/>

            <button type="button" className="btn-fil" onClick={onClose}>
              Cancelar
            </button>
          </div>
        </div>
        {/* FOOTER - Botones Guardar & Cancelar --Fin*/}
      </div>
    </div>
  );
}
